var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgD3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 105.124,
    y1: 18.816,
    x2: 258.888,
    y2: 180.747,
    id: "A",
    xlinkHref: "#G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a03c",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7974e",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -21.438,
    y1: 48.347,
    x2: 121.931,
    y2: 188.876,
    id: "B",
    xlinkHref: "#G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a03c",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7974e",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 44.776,
    y1: 97.471,
    x2: 174.952,
    y2: 242.691,
    id: "C",
    xlinkHref: "#G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a03c",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7974e",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 29.009,
    y1: -4.41,
    x2: 211.054,
    y2: 222.914,
    id: "D",
    xlinkHref: "#G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f26d58",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a03c",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 120.653,
    y1: 6.744,
    x2: 288.266,
    y2: 126.53,
    id: "E",
    xlinkHref: "#G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b84e51",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f68e48",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 83.051,
    y1: 171.518,
    x2: 91.707,
    y2: 286.309,
    id: "F",
    xlinkHref: "#G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9a03c",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7974e",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.125041 0 0 .125041 0 .844399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.52 175.62l.26-3.37c.078-1.34-80.562-77.85-80.562-77.85H173.3s81.736 86.215 82.23 81.22z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.472 149.077l-.323.704-.35.734c-2.57 5.36 35.987 43.053 39.088 38.474l.424-.618.467-.7c2.48-3.765-38.206-41.032-39.307-38.584z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.957 202.083c-.1.24-.885 1.552-1.594 2.245-.12.24 37.64 37.688 37.64 37.688h3.4c.002 0-35.446-38.35-39.446-39.933z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.835 171.568c-1.766 39.147-34.152 70.448-73.72 70.448h-5.35l-39.514-38.928c3.25-4.584 6.272-9.333 8.962-14.285h35.902c11.354 0 20.594-9.235 20.594-20.595 0-11.355-9.24-20.595-20.594-20.595H160.87c1.62-8.557 2.504-17.38 2.504-26.408 0-9.165-.9-18.114-2.578-26.808h13.197l81.6 80.414a91.25 91.25 0 0 0 .233-3.243zM21.467 0H0v53.213h21.467c37.493 0 68 30.5 68 67.992a67.6 67.6 0 0 1-6.318 28.576l39.163 38.6a120.48 120.48 0 0 0 20.376-67.166C142.688 54.373 88.307 0 21.467 0z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.115 0H95.187C116.42 12.963 134 31.344 145.98 53.213h36.136c11.354 0 20.594 9.235 20.594 20.595S193.47 94.4 182.115 94.4h-8.12l81.6 80.413c.192-2.18.312-4.376.312-6.605 0-17.94-6.437-34.395-17.125-47.203 10.688-12.802 17.125-29.26 17.125-47.197C255.917 33.112 222.813 0 182.115 0z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.765 242.016H95.808c16.296-10.064 30.384-23.35 41.443-38.928zm-54.453-53.645l-39.16-38.6c-10.82 23.25-34.395 39.422-61.685 39.422H0V242.4h21.467c42 0 79.1-21.488 100.845-54.04z",
    fill: "url(#F)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3);
export default __webpack_public_path__ + "static/media/d3.3693afdfe0d865f4b08ab1a5a2ed4081.svg";
export { ForwardRef as ReactComponent };